import { Stage } from "components/shared/stage/Stage";
import { GroupedStageOptions } from "components/shared/stage/types";
import Badge from "lib/core_components/Badge";
import { MultiSelectDropdown, Option } from "lib/core_components/MultiSelectDropdownList";
import UIcon from "lib/icons/untitled_ui/UIcon";

type Props = {
  onChange: (stageIds: string[]) => void;
  selectedStages: string[];
  options: GroupedStageOptions[];
  loading?: boolean;
};

export function StageDropdownFilter({ selectedStages, onChange, options, loading }: Props) {
  const flatOptions: Option<string>[] = options.flatMap((group) =>
    group.options.map((option) => ({
      title: option.label,
      value: option.value,
      OptionComponent: <Stage {...option} />,
    })),
  );

  return (
    <MultiSelectDropdown
      title={
        <>
          <UIcon icon="barChart10" color="sysPrimaryDefault" />
          {selectedStages.length > 0 && <Badge size={16}>{selectedStages.length}</Badge>}
        </>
      }
      fieldName="stage"
      hideSelectAll
      skipSort
      options={flatOptions}
      selectedOptions={selectedStages}
      onChange={onChange}
      loading={loading}
      showSelectedSizeBadge={false}
      hideChevron
    />
  );
}
